export const TARGET = "target"
export const SOURCE = "source"
export const SANKEY_SWITCHING_FLAG = "sankeySwitching"

export enum SANKEY_TYPE {
	PROFITS = "profit",
	LOSSES = "losses",
}

export enum SANKEY_MARGIN {
	ZERO = 0,
	SHORT = 10,
	LARGE = 250,
}

export const LIMITED_TITLE = 23
